import { Box, Flex, Heading } from '@chakra-ui/react';
import { i18n } from '@shared';
import { useState, useTransition } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { parseErrorToString, tavoittajaLogo } from '@shared';
import LoginForm from './SuperadminLoginForm';
import { SuperadminAuthService } from '../api/services/superadminAuthService';
import { useSuperadminAuth } from '../context/SuperadminAuthContext';
import usersService from '../api/services/usersService';

type Credentials = {
	email: string;
	password: string;
};

const TOKEN_NAME = import.meta.env.VITE_SUPERADMIN_TOKEN_NAME as string;

export function Login() {
	const [isPending, startTransition] = useTransition();
	const { setUser } = useSuperadminAuth();
	const [error, setError] = useState<string | null>(null);

	const methods = useForm<Credentials>({
		defaultValues: {
			email: '',
			password: '',
		},
	});

	const { handleSubmit } = methods;

	function login(credentials: Credentials): void {
		startTransition(async () => {
			try {
				setError(null);
				const response = await SuperadminAuthService.login(credentials);
				localStorage.setItem(TOKEN_NAME, response.jwt);

				const fetchedUser = await usersService.getSelf();
				setUser(fetchedUser);

				if (fetchedUser.language) {
					i18n.changeLanguage(fetchedUser.language);
				}
			} catch (loginError: unknown) {
				const errorString = parseErrorToString(loginError);
				setError(errorString);
			}
		});
	}

	return (
		<Flex justifyContent="center" alignItems="center" height="100vh" backgroundColor={'#F4F4F5'} padding={2}>
			<Box width={600} backgroundColor={'white'} borderRadius={12} overflow="hidden" boxShadow={'0px 4px 4px 0px rgba(0, 0, 0, 0.25)'}>
				<form onSubmit={handleSubmit(login)}>
					<FormProvider {...methods}>
						<Flex textAlign="center" flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={2}>
							<Flex alignItems={'center'} flexDirection={'column'} width={'100%'} padding={4} backgroundColor={'rgba(61, 213, 152, 1)'}>
								<img src={tavoittajaLogo} alt="Tavoittaja logo" width={90} height={90} />
								<Heading size="3xl" color="white">
									Tavoittaja
								</Heading>
							</Flex>
							<Flex flexDirection={'column'} padding={6} width={'100%'}>
								<LoginForm error={error} isPending={isPending} />
							</Flex>
						</Flex>
					</FormProvider>
				</form>
			</Box>
		</Flex>
	);
}
